import ReportHeatmapTable from "../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";


const HeatMap = ({data, boName}) => {
    return (
        <ReportHeatmapTable
            data={data?.bosByWeekday ?? []}
            title={`${boName} por dia da semana com intervalo de 1 hora`}
            sheetName={`${boName} por dia da semana`}
            columns={[
                { key: "segunda", label: "Segunda" },
                { key: "terca", label: "Terça" },
                { key: "quarta", label: "Quarta" },
                { key: "quinta", label: "Quinta" },
                { key: "sexta", label: "Sexta" },
                { key: "sabado", label: "Sábado" },
                { key: "domingo", label: "Domingo" },
            ]}
        />
    )
}

export default HeatMap;